exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview.non-shareable[data-v-bbd9a8ec]{color:#495057}.asset-preview.non-shareable .thumbnail[data-v-bbd9a8ec]{height:132px}.asset-preview.non-shareable .thumbnail img[data-v-bbd9a8ec]{max-height:130px}.asset-preview:hover .card-body .asset-info.stay[data-v-bbd9a8ec]{opacity:1}", ""]);

// exports
